import { useMatch } from 'react-router-dom';
import { cn } from '@yakit/ui-components';

import { VDLYearsButtons } from '@VDL/components/VDLYearsButtons';
import { VDLToolbarBackButton } from '@/modules/VDL/components/VDLToolbar/VDToolbarBackButton';
import {
  VDLEditToolbar,
  type OnToggleEdit
} from '@VDL/components/VDLEditToolbar';
import { VDLToggleSidebarButton } from '@VDL/components/VDLToggleSidebarButton';
import {
  VDLTablesButtons,
  type OnClickTableButton
} from '@VDL/components/VDLTablesButtons';
import { VDLToolbarTitle } from '@VDL/components/VDLToolbar/VDLToolbarTitle';

export interface VDLToolbarProps {
  isHaveEdit?: boolean;
  activeTableButtonCode?: string;
  isEdit?: boolean;
  editLabel?: string;
  onClickTableButton?: OnClickTableButton;
  onToggleEdit?: OnToggleEdit;
  onClickSave?: () => void;
}

export const VDLToolbar = ({
  isHaveEdit,
  activeTableButtonCode,
  isEdit,
  editLabel,
  onClickTableButton,
  onToggleEdit
}: VDLToolbarProps) => {
  const match = useMatch(':level0Code/*');

  return (
    <div>
      <div className="flex justify-between">
        <div className="flex items-center">
          {match && <VDLToggleSidebarButton className="md:hidden" />}
          <VDLYearsButtons className={cn('md:ml-0', { 'ml-2': match })} />
          <VDLToolbarTitle className="ml-2 hidden md:block" />
          <VDLToolbarBackButton variant="outline" size="sm" className="ml-2" />
        </div>
        <div className="flex gap-2">
          {isHaveEdit && (
            <VDLEditToolbar
              isEdit={isEdit ?? false}
              editLabel={editLabel}
              onToggleEdit={onToggleEdit}
            />
          )}
          <VDLTablesButtons
            activeTableButtonCode={activeTableButtonCode}
            onClickTableButton={onClickTableButton}
          />
        </div>
      </div>
      <div className="md:hidden">
        <VDLToolbarTitle className="line-clamp-2 pt-2 text-base" />
      </div>
    </div>
  );
};
